import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavBarComponent } from '../../components/nav-bar/nav-bar.component';
import { BottomTabBarComponent } from '../../components/bottom-tab-bar/bottom-tab-bar.component';
import { FooterComponent } from '../../footer/footer.component';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, NavBarComponent, BottomTabBarComponent, FooterComponent, CommonModule],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.css',
})
export class MainLayoutComponent {
  isFirmaPage = false;
  private router = inject(Router);

  ngOnInit() {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        this.isFirmaPage = e.url.startsWith('/firma/') || e.url.startsWith('/f/');
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      });
  }
}
